import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'numberOfOfficers',
    type: 'text',
    label: 'Number Of Officers',
  },
  {
    colSpan: 1,
    name: 'numberOfStaff',
    type: 'text',
    label: 'Number Of Staff',
  },
  {
    colSpan: 1,
    name: 'noOfMale',
    type: 'text',
    label: 'Male',
  },
  {
    colSpan: 1,
    name: 'noOfFemale',
    type: 'text',
    label: 'Female',
  },
];

export const humanResFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label),
  [fields[1].name]: yup.string().label(fields[1].label),
  [fields[2].name]: yup.string().label(fields[2].label),
  [fields[3].name]: yup.string().label(fields[3].label),
};

const HumanResources = (props) => {
  return (
    <FormSection sectionName="Human Resources" sectionColumn={4} formFields={fields} {...props} />
  );
};

export default HumanResources;
